import { render, staticRenderFns } from "./View.vue?vue&type=template&id=a154aa7e&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
import style0 from "./View.vue?vue&type=style&index=0&id=a154aa7e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a154aa7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a154aa7e')) {
      api.createRecord('a154aa7e', component.options)
    } else {
      api.reload('a154aa7e', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=a154aa7e&scoped=true", function () {
      api.rerender('a154aa7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/ui-components/pcnews/View.vue"
export default component.exports